import * as moment from 'moment';
import { sweetAlert } from 'src/app/utils/swal';
export const NUMBER_OF_RECORDS = 50;
export const INVOICE_STATUS_STAT_CARDS = [
  { key: 'total', label: 'Total' },
  { key: 'created', label: 'Created' },
  { key: 'pending', label: 'Pending' },
];
export const INVOICE_AMOUNT_STAT_CARDS = [
  { key: 'totalAmount', label: 'Total' },
  { key: 'paidAmount', label: 'Paid' },
  { key: 'unpaidAmount', label: 'Unpaid' },
];
export const BILL_PAYMENT_ENTITY_STAT_CARDS = [
  { key: 'total', label: 'Total' },
  { key: 'created', label: 'Created' },
  { key: 'pending', label: 'Pending' },
];
export const BILL_PAYMENT_ENTITY_AMOUNT_STAT_CARDS = [
  { key: 'totalAmount', label: 'Total' },
];
export const PAYMENT_ENTITY_STAT_CARDS = [
  { key: 'total', label: 'Total' },
  { key: 'created', label: 'Created' },
  { key: 'pending', label: 'Pending' },
];
export const PAYMENT_ENTITY_AMOUNT_STAT_CARDS = [
  { key: 'totalAmount', label: 'Total' },
  { key: 'depositedAmount', label: 'Deposited' },
  { key: 'notDepositedAmount', label: 'Not Deposited' },
];
export const BILL_PAYMENT_STAT_CARDS = [
  { key: 'total', label: 'Total', filter: '' },
  { key: 'paid', label: 'Paid', filter: 'Paid' },
  { key: 'partiallyPaid', label: 'Partially Paid', filter: 'Partially Paid' },
  { key: 'unpaid', label: 'Unpaid', filter: 'Unpaid' },
  { key: 'dueToday', label: 'Due Today', filter: 'Due Today' },
  { key: 'overdue', label: 'Overdue', filter: 'Overdue' },
  { key: 'upcoming', label: 'Upcoming', filter: 'Upcoming' },
];
export const BILL_AMOUNT_STAT_CARDS = [
  { key: 'totalAmount', label: 'Total' },
  { key: 'amountPaid', label: 'Paid' },
  { key: 'outstandingAmount', label: 'Unpaid' },
];
const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10MB
const maxFileSize = 10
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";


export function formatDuration(durationValue:any) {
    // Convert the duration into a moment duration object
    let duration = moment.duration(durationValue, 'seconds');
    // Extract hours and minutes from the duration
    let hours = Math.floor(duration.asHours());  // Get the integer value of hours
    let minutes = duration.minutes();  // Get the remaining minutes
    // Return the result based on the hours
    if (hours > 0) {
      return `${hours} hr ${minutes} mins`;
    } else {
      return `${minutes} mins`;
    }
};


pdfMake.vfs = pdfFonts.pdfMake.vfs;


pdfMake.fonts = {
  Roboto: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  },
  FontAwesome: {
    normal: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.ttf"
  }
};
  
export function formatDistance(distance:any) {
  return `${ roundUp(Number((distance / 1609.344).toFixed(2))) } mi`;
}

export function exportToCsv(filename:any, rows:any) {
  var processRow = function (row:any) {
    var finalVal = '';
    for (var j = 0; j < row.length; j++) {
      var innerValue = row[j] === null || row[j] === undefined || row[j] === "" ? 'n/a' : row[j].toString();
      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString();
      };
      var result = innerValue.replace(/"/g, '""');
      if (result.search(/("|,|\n)/g) >= 0)
        result = '"' + result + '"';
      if (j > 0)
        finalVal += ',';
      finalVal += result;
    }
    return finalVal + '\n';
  };

  var csvFile = '';
  for (var i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i]);
  }

  var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });

  var link = document.createElement("a");
  if (link.download !== undefined) { // feature detection
    // Browsers that support HTML5 download attribute
    var url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }
}



export function generatePdf(documentDefinition: any, action: "download" | "open" | "print" = "download", filename = "black-honda") {
  return new Promise<void>((resolve, reject) => {
    try {
      const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

      switch (action) {
        case "open":
          pdfDocGenerator.open();
          resolve();
          break;
        case "print":
          pdfDocGenerator.print();
          resolve();
          break;
        case "download":
          pdfDocGenerator.download(`${filename}.pdf`);
          resolve();
          break;
        default:
          pdfDocGenerator.open();
          resolve();
          break;
      }
    } catch (err) {
      reject(err);
    }
  });
}

export function getRandomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result
}

export async function urlToBase64(url: string): Promise<string> {
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache"
      }
    });

    if (!res.ok) {
      return "";
    }

    const blob = await res.blob();

    // WEBP -> PNG conversion
    if (blob.type === "image/webp") {
      return await webpToPng(blob);
    }

    return await new Promise<string>((resolve) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result as string);
      };

      reader.onerror = () => {
        resolve("");
      };

      reader.readAsDataURL(blob);
    });

  } catch (error) {
    console.warn(error);
    return "";
  }
}

async function webpToPng(blob: Blob): Promise<string> {
  return new Promise((resolve) => {
    const img = new Image();

    img.onload = () => {
      const canvas = document.createElement("canvas");

      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");

      if (!ctx) {
        resolve("");
        return;
      }

      ctx.drawImage(img, 0, 0);

      resolve(canvas.toDataURL("image/png"));
    };

    img.onerror = () => resolve("");

    img.src = URL.createObjectURL(blob);
  });
}

export function base64ToFile(base64Data: string, filename: string): File {
  const arr = base64Data.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/png';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export function roundUp(value: number): number {
  return Math.ceil(value);
}

export function validateFileSize(file?: File | null): boolean {
  if (!file) return true;

  if (file.size > MAX_FILE_SIZE_BYTES) {
    sweetAlert(
      'File too large',
      `Maximum file size allowed is ${maxFileSize} MB.`,
      'warning',
      'OK'
    );
    return false;
  }

  return true;
}

export function getCompanyEmail(company: any): string {
  if (!company) return '';
  if (typeof company.PrimaryEmailAddr === 'string' && company.PrimaryEmailAddr.trim()) {
    return company.PrimaryEmailAddr.trim();
  }
  return (
    company.PrimaryEmailAddr?.Address ||
    company.Email?.Address ||
    company.CustomerCommunicationEmailAddr?.Address ||
    ''
  ).trim();
}

export function getBillBalance(bill: any) {
  const total = Number(bill?.TotalAmt ?? 0);
  const stored = Number(bill?.Balance);
  if (!bill?.Id && !(stored > 0)) {
    return total;
  }
  if (bill?.Balance == null || bill?.Balance === '') {
    return total;
  }
  return stored || 0;
}

export function getPaymentStatus(bill: any) {
  const total = Number(bill?.TotalAmt ?? 0);
  const balance = getBillBalance(bill);
  const due = String(bill?.DueDate || '').slice(0, 10);
  const today = moment().format('YYYY-MM-DD');
  const amountPaid = Math.max(0, total - balance);
  if (bill?.Id && total > 0 && balance <= 0) return 'Paid';
  if (bill?.Id && balance > 0 && due && due < today) return 'Overdue';
  if (bill?.Id && balance > 0 && due === today) return 'Due Today';
  if (amountPaid > 0 && balance > 0) return 'Partially Paid';
  if (bill?.Id && balance > 0 && due && due > today) return 'Upcoming';
  return 'Unpaid';
}

export function getPaymentStatusClass(status: any) {
  if (status === 'Paid') return 'badge-success';
  if (status === 'Partially Paid' || status === 'Upcoming') return 'badge-primary';
  if (status === 'Overdue' || status === 'Due Today' || status === 'Unpaid' || status === 'Pending') return 'badge-warning';
  return 'badge-warning';
}

// Invoice payment status comes from the API (invoice.paymentStatus: { key, label, subLabel }) — same block in broker panel & quickbooks panel
const INVOICE_PAYMENT_STATUS_CLASS: { [key: string]: string } = {
  overdue: 'badge-danger',
  due: 'badge-warning',
  not_deposited: 'badge-secondary',
  deposited: 'badge-success',
  paid: 'badge-success',
};
const INVOICE_PAID_STATUSES = ['paid', 'not_deposited', 'deposited'];

// Precompute invoice row display values once when the list loads (templates bind fields — no helper calls per change detection)
export function toInvoiceRow(invoice: any) {
  const key = invoice?.paymentStatus?.key;
  return {
    ...invoice,
    amountPaid: getAmountPaid(invoice),
    remainingBalance: getRemainingBalance(invoice),
    paymentStatusClass: INVOICE_PAYMENT_STATUS_CLASS[key] || 'badge-secondary',
    canReceivePayment: !!invoice?.Id && !INVOICE_PAID_STATUSES.includes(key),
  };
}

export function getAmountPaid(bill: any) {
  const total = Number(bill?.TotalAmt ?? 0);
  return Math.max(0, total - getBillBalance(bill));
}

export function getRemainingBalance(bill: any) {
  return getBillBalance(bill);
}

export function getBillPaymentTypeLabel(payment: any) {
  if (!payment?.Id) return 'Bill Payment (Pending)';
  return +payment.TotalAmt > 0 ? 'Bill Payment' : 'Bill Payment (Voided)';
}

export function getInvoicePaymentTypeLabel(payment: any) {
  if (!payment?.Id) return 'Payment (Pending)';
  return +payment.TotalAmt > 0 ? 'Payment' : 'Payment (Voided)';
}

const NON_TRANSACTIONAL_ITEM_TYPES = ['Category', 'Group', 'Bundle'];

export function isPurchasableProductItem(item: any): boolean {
  if (!item?.Id) return false;
  if (item.Active === false) return false;
  if (NON_TRANSACTIONAL_ITEM_TYPES.includes(item.Type)) return false;
  return !!item.ExpenseAccountRef?.value;
}

export function getPurchasableProductItems(items: any): any[] {
  return (items || []).filter((item: any) => isPurchasableProductItem(item));
}
